import React from 'react';
import { NavigationPage } from '../../../../Redux/Reducers/NavigationReducer';
import { ItemTypeConstants } from '../../../../Resources/ItemTypeConstants';
import { CatalogObjectDisplayObject } from '../../../Data/CatalogObjectDisplayObject';

import { DynamicItemComponent } from './Items/DynamicItemComponent';
import { StaticItemComponent } from './Items/StaticItemComponent';

type StaticTableComponentParameters = {
  title : string,
  itemsList : Array<CatalogObjectDisplayObject>,
  itemsType : 'STATIC' | 'DYNAMIC',
  displayNewPage : (collectionName: string, objectName: string, pageType: string) => void,
  noContentText : string
};

export function StaticTableComponent({
  title,
  itemsList,
  itemsType,
  displayNewPage,
  noContentText,
} : StaticTableComponentParameters) {

  const getTableColumn = (
    item : CatalogObjectDisplayObject,
    index : number,
  ) => {

    return (
      <div
        className="static-table col padding-0"
        key={index}
      >
        {itemsType === ItemTypeConstants.STATIC_ITEMS ? (

          <StaticItemComponent
            item={item}
            showPage={displayNewPage}
            pageType={NavigationPage.Object}
            key={index}
          />
        ) : (
          <DynamicItemComponent
            item={item}
            showPage={displayNewPage}
            pageType={NavigationPage.Object}
            key={index}
            noContentText={noContentText}
          />
        )}
      </div>
    );
  };

  return (
    <div className="container" style={{ overflowY: 'auto' }}>
      <div className="row">
        <div className="col">
          <h1 style={{ textAlign: 'left', fontSize: '20pt' }}>{title}</h1>
        </div>
      </div>
      <div className="row" style={{ marginBottom: '30px' }}>
        {itemsList.map((item, index) => getTableColumn(item, index))}
      </div>
    </div>
  );
}
